import type { FC, ReactNode } from 'react';
import { cn } from '@/lib/utils';

type DashboardMetricCardProps = {
  label: string;
  value: ReactNode;
  highlight?: boolean;
  className?: string;
};

export const DashboardMetricCard: FC<DashboardMetricCardProps> = ({
  label,
  value,
  highlight = false,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex min-h-[92px] min-w-0 flex-col justify-between rounded-sm border px-5 py-4',
        highlight
          ? 'border-brand-secondary bg-brand-secondary text-white'
          : 'border-border-subtle bg-card text-brand-secondary-bright shadow-[0_0_0_1px_rgb(14_153_242_/_0.5)] dark:text-foreground dark:shadow-none',
        className,
      )}
    >
      <p
        className={cn(
          'font-label',
          highlight ? 'text-white' : 'text-text-subtle',
        )}
      >
        {label}
      </p>
      <p
        className={cn(
          'font-display text-display-2 tracking-tight',
          highlight ? 'leading-[26px]' : 'leading-8',
        )}
      >
        {value}
      </p>
    </div>
  );
};

type DashboardMetricCardsProps = {
  items: Array<{
    label: string;
    value: ReactNode;
    highlight?: boolean;
  }>;
  className?: string;
};

export const DashboardMetricCards: FC<DashboardMetricCardsProps> = ({
  items,
  className,
}) => {
  return (
    <div className={cn('grid min-w-0 gap-3 sm:grid-cols-2 xl:grid-cols-4', className)}>
      {items.map((item) => (
        <DashboardMetricCard key={item.label} {...item} />
      ))}
    </div>
  );
};
